import 'moment/locale/fi';
import React from 'react';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { v1 as uuidv1 } from 'uuid';
import { requestUpdateTask } from '../../actions/task';
import { getLocalizedDateTime, getLocalizedString } from '../../localization/LocalizedString';
import Button from '../forms/Button';
import './UpdateTask.css';
import TimePicker from '../../views/24hTimePicker/TimePicker';

const secondsToMinutes = (seconds) => {
  let timer = `${Math.floor(seconds / 60)}:`;

  const secs = seconds % 60;
  if (secs < 10) {
    timer += '0';
  }
  timer += secs;

  return timer;
};

class UpdateTask extends React.Component {
  constructor(props) {
    super(props);
    this.requestId = uuidv1();

    this.state = {
      startTime: '',
      endTime: '',
      editStartDate: null,
    };
  }

  onSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const { startTime, endTime, start } = this.state;
    const { requestUpdateTask, translate } = this.props;
    const data = {
      requestId: this.requestId,
      employeeId: this.props.task.employeeId,
      userId: this.props.task.userId,
      taskId: this.props.task.taskId,
      sequenceNumber: 0,
      destinationId: this.props.task.destinationId,
      serviceSiteId: this.props.task.serviceSiteId,
      serviceId: this.props.task.serviceId,
      additionalFeatures: this.props.task.additionalFeatures,
      taskType: 'manual',
      billed: null,
    };

    for (const [key, value] of formData.entries()) {
      data[key] = value;
    }

    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    const taskStartTime = `${startDate.getHours()}:${startDate.getMinutes()}`;
    const taskEndTime = `${endDate.getHours()}:${endDate.getMinutes()}`;

    data.startTime = moment(`${start} ${taskStartTime}`).toDate();
    data.endTime = moment(`${start} ${taskEndTime}`).toDate();

    if (data.endTime < data.startTime) {
      toast.error(translate('new_task.invalid_duration'));
      return;
    }

    if (start !== undefined) {
      requestUpdateTask(JSON.stringify(data), (e) => {
        console.log(e);
        toast.error(translate('new_task.save_failed'));
      },
      () => this.props.onSaved());
    } else {
      this.setState({ editStartDate: null });
    }
  }

  getServiceOptions() {
    const { currentLanguage, serviceSite } = this.props;
    const { services } = serviceSite || {};

    return (services || []).map((service) => ({
      value: service.id,
      text: getLocalizedString(service.name, currentLanguage),
    }));
  }

  onHandleChange24hTimePickerEvt = (evt) => {
    if (evt.isStartTime) {
      this.setState({ startTime: evt.pickedTime });
    } else {
      this.setState({ endTime: evt.pickedTime });
    }
  }

  taskDateUpdate = (editStartDate) => {
    this.setState({
      editStartDate,
      start: editStartDate ? moment(editStartDate).format('YYYY-MM-DD') : undefined,
    });
  }

  render() {
    const { translate, task, currentLanguage } = this.props;
    const { editStartDate } = this.state;

    return (
      <form onSubmit={this.onSubmit.bind(this)}>

        <div className="update-task">
          <div className="row first-row">
            <div className="col-lg-6 col-md-12">
              <h3>
                {translate('update_task_modal.executed')}
                {' '}
                {getLocalizedDateTime(new Date(task.totalEndTime), currentLanguage)}
              </h3>
              <h3>
                {translate('update_task_modal.duration')}
                {' '}
                {secondsToMinutes(task.totalDuration)}
                {' '}
                {translate('update_task_modal.minutes')}
              </h3>
              <h3>
                {translate('update_task_modal.service')}
                :
                {' '}
                {getLocalizedString(task.service.name, currentLanguage)}
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="row">
                <div className="col-sm-12"><h3>{translate('new_task.change_date')}</h3></div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <DatePicker
                    name="date"
                    className="app-date-picker-input"
                    selected={editStartDate}
                    onChange={this.taskDateUpdate}
                    dateFormat={['dd.MM.yyyy', 'd.M.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']}
                    strictParsing
                    locale={currentLanguage === 'fi' ? 'fi' : 'en'}
                    placeholderText="DD.MM.YYYY"
                    popperClassName="app-date-picker-popper"
                    portalId="app-date-picker-portal"
                    showPopperArrow={false}
                    autoComplete="off"
                    required />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="row">
                <div className="col-sm-12"><h3>{translate('new_task.start_stop_time')}</h3></div>
              </div>
              <div className="row display-flex">

                <div className="col-xs-9">
                  <TimePicker name="start"
                              selectedTime={this.onHandleChange24hTimePickerEvt}
                              required
                              stepValue={0}
                              isStartTime />
                </div>
                <div className="time-selector-seperator"><span>&mdash;</span></div>
                <div className="col-xs-9 end-24h-time-picker">
                  <TimePicker name="end"
                              selectedTime={this.onHandleChange24hTimePickerEvt}
                              required
                              stepValue={0}
                              isStartTime={false} />
                </div>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <Button onClick={this.props.onCancel}>{translate('form.reset')}</Button>
            </div>
            <div className="col-sm-6">
              <Button>{translate('new_task.change_time')}</Button>
            </div>
          </div>
        </div>

      </form>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLang = getActiveLanguage(locale);

  return {
    translate: getTranslate(locale),
    currentLanguage: (activeLang && activeLang.code) || 'fi',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestUpdateTask,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateTask);
